<template>
    <forget-password-form />
</template>
<script>
import ForgetPasswordForm from './form/ForgetPasswordForm';

export default {
    name: 'forget-password-page',
    components: {
        ForgetPasswordForm
    }
};
</script>

